import ParcelBookingForm from "@/components/ParcelBookingForm";
import { Card } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/auth-provider";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const { user, loading: authLoading } = useAuth();
  const [localLoading, setLocalLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading) {
      setLocalLoading(false);
    }
  }, [authLoading]);

  useEffect(() => {
    if (!authLoading && !user && !localLoading) {
      navigate('/auth');
      return;
    }
  }, [localLoading, user, authLoading, navigate]);

  // Show loading state
  if (authLoading || localLoading) {
    return (
      <div className="container max-w-3xl px-4 py-8 overflow-x-hidden">
        <Card className="p-6">
          <div className="flex justify-center">
            <p>Loading...</p>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="overflow-x-hidden w-full">
      <ParcelBookingForm />
    </div>
  );
};
export default Index;
